// extracted by mini-css-extract-plugin
export default {"watch":"Watch_watch__3iKRy","hand":"Watch_hand__cVDMo","hour":"Watch_hour__28-Dx","minute":"Watch_minute__tmwqO","second":"Watch_second__dhO-1"};